import React, { useEffect } from 'react';
import { PageHero } from '../components/page/PageHero';
import { IncludedList } from '../components/page/IncludedList';
import { WhyLawyerLed } from '../components/page/WhyLawyerLed';
import { Process } from '../components/home/Process';
import { FeeTransparency } from '../components/page/FeeTransparency';
import { MiniFAQ } from '../components/page/MiniFAQ';
import { FinalCTA } from '../components/home/FinalCTA';
const INCLUDED = [{
  title: 'Contract and disclosure review',
  body: 'We read the contract of sale and relevant disclosure documents and explain what they mean for you before you commit.'
}, {
  title: 'Special-condition advice',
  body: 'Finance, building and pest, subject-to-sale and other conditions reviewed so you understand your obligations.'
}, {
  title: 'Title and disclosure checks',
  body: 'Easements, covenants, owners corporation and disclosure matters considered as part of the review.'
}, {
  title: 'Auction and private sale',
  body: 'Advice tailored to how you are buying, including the unconditional nature of most auction contracts.'
}, {
  title: 'Settlement coordination',
  body: 'The team manages documents, dates, adjustments and settlement so the purchase completes properly.'
}, {
  title: 'Questions answered directly',
  body: 'Speak with the team handling your file when something needs clarifying, not a call centre.'
}];
const FAQS = [{
  q: 'When should I have the contract reviewed?',
  a: 'Before signing or bidding wherever possible. A review can identify conditions, disclosures and risks that may affect your decision or require further advice.'
}, {
  q: 'Can you review a contract before auction?',
  a: 'Yes. The contract should ideally be reviewed before auction day because auction contracts are generally unconditional once the property is purchased. Send the contract and auction date with your enquiry.'
}, {
  q: 'What does it cost?',
  a: 'You receive a clear scope and fee before any work begins, so you can decide with the cost in front of you. Send the details for a quote.'
}];
export function BuyingProperty() {
  useEffect(() => {
    document.title = 'Buying Property in Australia | L.A Property Law';
    window.scrollTo(0, 0);
  }, []);
  return <main data-id="element-583" data-mp="3ejq1p0382cho">
      <PageHero eyebrow="buying property" title="Know what you are signing before you buy." intro="Get the contract reviewed, understand the conditions and find out what needs attention before you commit to an Australian property purchase." data-id="element-584" data-mp="3ek9kej0p54wr" />
      <IncludedList eyebrow="what is included" heading="Buyer support from contract to settlement." intro="A lawyer-led review of the contract and vendor statement, followed by coordinated management through to settlement." items={INCLUDED} data-id="element-585" data-mp="2quxcdmh3v2w1" />
      <WhyLawyerLed data-id="element-586" data-mp="b3spympewwh8" />
      <Process data-id="element-587" data-mp="b39fts607cdr" />
      <FeeTransparency variant="background" data-id="element-588" data-mp="b2rbe896trur" />
      <MiniFAQ items={FAQS} data-id="element-589" data-mp="1vm3ih5wsryvl" />
      <FinalCTA data-id="element-590" data-mp="1vmd128fij3r9" />
    </main>;
}